import { API } from "aws-amplify";
import moment from "moment";
import {
  sendEmail as sendEmailAction,
  sendInitalEmailBulk as sendInitalEmailBulkAction,
  sendRoadTestSlotOrTimeEmailsBulk as sendRoadTestSlotOrTimeEmailsBulkAction,
  sendRoadTestResultEmailsBulk as sendRoadTestResultEmailsBulkAction,
  checkEmailDate as checkEmailDateAction,
} from "./emailActions";
import {
  sortSlots as sortSlotsUtil,
  buildGeneratedSlots,
  buildGeneratedUnslottedGroupTimes,
  buildFilledLeftovers,
} from "./slotUtils";
import StudentManagementModal from "./StudentManagementModal";
import ManageLessonsModal from "./ManageLessonsModal";
import SlotStudentsCard from "./SlotStudentsCard";
import WeekdaySlotStudentsCard from "./WeekdaySlotStudentsCard";
import SendSlotEmailCard from "./SendSlotEmailCard";
import SendInitialEmailCard from "./SendInitialEmailCard";
import React from "react";
import {
  Accordion,
  Alert,
  Button,
  Card,
} from "react-bootstrap";
import DayPicker from "react-day-picker";
import { CSVLink } from "react-csv";
import { Locations } from "../../components/contstants/Locations";
import {
  CSV_HEADERS,
  WEEKDAY_BUTTONS,
} from "../../components/contstants/AppointmentConstants";
import {
  logAPIError,
  cleanNullProperties,
  copyToClipboard,
  isRMVOrGraniteLocation,
  buildAPIOptions,
} from "../../utils/appointmentUtils";
import { downloadStudentImportXlsx } from "../../utils/studentImportExport";
import ManageStudentsCard from "./ManageStudentsCard";
import ViewLessonStatusCard from "./ViewLessonStatusCard";
import CertStatusCard from './CertStatusCard';
import RoadTestResultCard from './RoadTestResultCard';

import "./Appointment.css";

export default class Registration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addModalErrors: {},

      activeKey: "selectDays",
      selectedDay: "",
      fetchedStudents: false,
      APIDateStudentResults: [],
      filteredAPIDateStudentResults: [],
      selectedLocation: "",
      selectedWeekday: "",
      unslotedMembers: [],
      selectedDaysRange: "",

      addModalValidated: false,

      unsavedManuallyAddedStudents: [],
      studentImportWarnings: [],

      selectedTimeSlot: { label: "10 Minutes", value: 10 },
      slotTime: 10,
      startTime: "43200",
      endTime: "64800",

      slots: [],
      selectedDays: [],
      selectedRealDays: [],

      dayOfExam: "",
      preSlottedMembers: [],

      emailSendDateData: "",
      //For use in modals
      showModal: false,
      //modalView: "",
      modalView: "add",
      //For lesson modal
      showManageLessons: false,
      showAddLessons: false,
      showRemoveLessons: false,
      selectedLessonStudent: {},
      selectedLessonValue: {},
      selectedLessonLocation: "",
      newLessonsToAdd: [],
      selectedLessonStudentIndex: 0,
      //For if add UserModal is used
      firstName: "",
      middleName: "",
      lastName: "",
      dateOfBirth: "",
      permitNumber: "",
      permitIssueDate: "",
      email: "",
      phoneNumber: "",
      roadTestPackageOption: "",
      paymentType: "",
      price: "",
      avaliableOptions: [],
      drivingSchool: "",
      location: "",
      addCompletionCertificate: false,
      disabledButtons: [],

      selectedStudent: 0,
      newCopyMoveDate: null,
      newEditMoveDate: null,
      moveError: "",
      copyError: "",
      deleteError: "",

      rawRoadTestLessons: [],

      addLessonValidated: false,
      CCFirstName: "",
      CCLastName: "",
      CCExpiration: "",
      CCCode: "",
      CCAddress: "",
      CCCity: "",
      CCState: "",
      CCZip: "",
      CCCountry: "USA",
      CCNumber: "",
      CCLessonsWanted: 1,
      CCLessonsPrice: 0,
      CCErrors: "",
      skipExtraLessonsPayment: false,

      locations: Locations,
      unslotedGroupTimes: [],
    };
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleFirstNextButton = this.handleFirstNextButton.bind(this);
    this.handleDayOfWeekButton = this.handleDayOfWeekButton.bind(this);
    this.handleModalChange = this.handleModalChange.bind(this);
    this.onRadioPackageChange = this.onRadioPackageChange.bind(this);

    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndtimeTimeChange = this.handleEndtimeTimeChange.bind(this);
    this.handleSlotDurationChange = this.handleSlotDurationChange.bind(this);

    this.addNewStudents = this.addNewStudents.bind(this);
    this.handleMoveStudent = this.handleMoveStudent.bind(this);
    this.handleCopyStudent = this.handleCopyStudent.bind(this);
    this.handleDeleteStudent = this.handleDeleteStudent.bind(this);

    this.handleAddNewUser = this.handleAddNewUser.bind(this);
    this.handleAddNewLessons = this.handleAddNewLessons.bind(this);
    this.sortSlots = this.sortSlots.bind(this);
    this.handleSlotMove = this.handleSlotMove.bind(this);
    this.handleSlotClear = this.handleSlotClear.bind(this);
    this.handleSlotDelete = this.handleSlotDelete.bind(this);
    this.handleSlotSave = this.handleSlotSave.bind(this);
    this.handleUnslottedTimeSave = this.handleUnslottedTimeSave.bind(this);

    this.checkEmailDate = this.checkEmailDate.bind(this);
    this.renderUnslottedStudentTimes =
      this.renderUnslottedStudentTimes.bind(this);

    this.handleLessonDateChange = this.handleLessonDateChange.bind(this);
    this.deleteNewLesson = this.deleteNewLesson.bind(this);
    this.deleteOldLesson = this.deleteOldLesson.bind(this);

    this.addAdditionalLessons = this.addAdditionalLessons.bind(this);

    this.loadRoadTestLessonDates = this.loadRoadTestLessonDates.bind(this);
    this.handleNewMoveDateChoice = this.handleNewMoveDateChoice.bind(this);
    this.handleNewCopyDateChoice = this.handleNewCopyDateChoice.bind(this);
    this.sendInitalEmailBulk = this.sendInitalEmailBulk.bind(this);
    this.sendRoadTestResultEmailsBulk =
      this.sendRoadTestResultEmailsBulk.bind(this);
    this.sendRoadTestSlotOrTimeEmailsBulk =
      this.sendRoadTestSlotOrTimeEmailsBulk.bind(this);
    this.saveNewLessons = this.saveNewLessons.bind(this);
    this.removeAdditionalLessons = this.removeAdditionalLessons.bind(this);
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://js.authorize.net/v1/Accept.js";
    script.async = true;
    document.body.appendChild(script);

    const that = this;
    //We need to grab stuff
    fetch("https://s3.amazonaws.com/publicdates/roadTestDates.json", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then(this.handleErrors)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        that.setState({ rawRoadTestLessons: typeof data === "string" ? JSON.parse(data) : data });
      });

    fetch("https://s3.amazonaws.com/publicdates/roadTestPackages.json", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then(this.handleErrors)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        that.setState({ avaliableOptions: data });
      });
  }

  async handleDayClick(date, { selected }) {
    let dayOfWeek = date.getDay();
    let selectedDays = [];
    let selectedRealDays = [];
    if (dayOfWeek === 0) {
      //They picked a Sunday, but we really want the start of the weekend
      selectedDays.push(moment(date).subtract(1, "d").toDate());
      selectedDays.push(moment(date).toDate());
    } else if (dayOfWeek === 6) {
      //They picked a Saturday, no changes needed
      selectedDays.push(moment(date).toDate());
      selectedDays.push(moment(date).add(1, "d").toDate());
    } else {
      selectedRealDays.push(moment(date).toDate());
      selectedDays.push(moment(date).toDate());
    }
    selectedRealDays = selectedRealDays.concat(selectedDays);

    this.setState(
      {
        selectedRealDays,
        selectedDays,
        selectedLocation: "",
        selectedWeekday: "",
      },
      () => this.processLocationSlots(),
    );
  }

  processLocationSlots = async () => {
    let selectedDaysRange = "";

    let selectedDay = this.state.selectedDays[0];
    var location = this.state.selectedLocation;
    let APIDateStudentResults = await this.handleGetSlotsbyDay(selectedDay);
    let filteredData = [];
    let slots = [];
    var preSlottedFolks = [];
    if (location.length === 0) {
      var selectedLocationSet = new Set(
        APIDateStudentResults.filter((x) => x.location).map((x) => x.location),
      );
      var selectedDateLocations = [...selectedLocationSet];
      if (selectedDateLocations.length === 1) {
        location = selectedDateLocations[0];
      }
    }
    if (location.length > 0) {
      filteredData = APIDateStudentResults.filter(
        (x) => x.location === location,
      );
    }

    if (selectedDay.getDay() === 6) {
      selectedDaysRange += moment(selectedDay).format("LL");
      if (filteredData.length > 0) {
        var selectedWeekenedDates = new Set(
          filteredData.filter((x) => x.weekendDate).map((x) => x.weekendDate),
        );

        selectedWeekenedDates = [...selectedWeekenedDates];
        if (selectedWeekenedDates.length > 0) {
          //Only one date, let's assume it's that one and move on.
          var selectedWeekday = selectedWeekenedDates[0];
          var weekendArray = ["Saturday", "Sunday"];
          if (weekendArray.includes(selectedWeekday)) {
            preSlottedFolks = filteredData.filter((x) => x.slot);
            if (preSlottedFolks.length > 0) {
              slots = preSlottedFolks.map(function (x) {
                return {
                  slotName: x.slot,
                  person: x.fName + " " + x.lName,
                  value: x,
                };
              });
              this.setState({
                dayOfExam:
                  this.state.selectedDays[
                  weekendArray.indexOf(selectedWeekday)
                  ],
                selectedWeekday,
              });
            }
          } else {
            weekendArray = [
              "Saturday",
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
            ];
            preSlottedFolks = filteredData.filter((x) => x.slot);
            if (preSlottedFolks.length > 0) {
              slots = preSlottedFolks.map(function (x) {
                return {
                  slotName: x.slot,
                  person: x.fName + " " + x.lName,
                  value: x,
                };
              });
              this.setState({
                dayOfExam: moment(selectedDay).add(
                  weekendArray.indexOf(selectedWeekday),
                  "days",
                ),
                selectedWeekday,
              });
            }
          }
        }
      } else {
        this.setState({ dayOfExam: selectedDay, selectedWeekday: "" });
      }
    } else {
      selectedDaysRange = moment(selectedDay).format("ddd, LL");
      preSlottedFolks = filteredData.filter((x) => x.slot);
      if (filteredData.length > 0) {
        selectedWeekenedDates = new Set(
          filteredData.filter((x) => x.weekendDate).map((x) => x.weekendDate),
        );

        selectedWeekenedDates = [...selectedWeekenedDates];
        if (selectedWeekenedDates.length > 0) {
          //Only one date, let's assume it's that one and move on.
          selectedWeekday = selectedWeekenedDates[0];

          weekendArray = [
            "Saturday",
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
          ];
          preSlottedFolks = filteredData.filter((x) => x.slot);
          console.log(selectedWeekday);

          if (preSlottedFolks.length > 0) {
            slots = preSlottedFolks.map(function (x) {
              return {
                slotName: x.slot,
                person: x.fName + " " + x.lName,
                value: x,
              };
            });
            this.setState({
              dayOfExam: moment(selectedDay)
                .subtract(2, "day")
                .add(weekendArray.indexOf(selectedWeekday), "days"),
              selectedWeekday,
            });
          }
        } else {
          //No date was selected but there can only be one date.
          console.log(moment(selectedDay).format("dddd"));
          this.setState({
            dayOfExam: selectedDay,
            selectedWeekday: moment(selectedDay).format("dddd"),
            selectedDaysRange,
          });
          this.setState({
            selectedTimeSlot: { label: "60 Minutes", value: 60 },
            slotTime: 60,
          });
          var unslotTimes = filteredData
            .filter((x) => x.location === location)
            .filter((x) => !x.slot)
            .filter((x) => x.hasOwnProperty("unslotTime"))
            .map((x) => ({ slotName: x.unslotTime }));
          unslotTimes = [...new Set(unslotTimes)];
          this.setState({
            unslotedGroupTimes: this.sortSlots(unslotTimes, "slotName"),
          });
        }
      }

      if (preSlottedFolks.length > 0) {
        slots = preSlottedFolks.map(function (x) {
          return {
            slotName: x.slot,
            person: x.fName + " " + x.lName,
            value: x,
          };
        });
      }
    }
    //We need to figure out if there is an already selected Weekday from all of the students that were fetched.

    //The selected date is the first entry of the selectedDays
    slots = this.sortSlots(slots, "slotName");
    this.setState({
      selectedDay,
      APIDateStudentResults,
      selectedDaysRange,
      unsavedManuallyAddedStudents: [],
      selectedLocation: location,
      filteredAPIDateStudentResults: filteredData,
      unslotedMembers: filteredData
        .filter((x) => x.location === location)
        .filter((x) => !x.slot),
      slots,
    });
  };

  handleGetSlotsbyDay = async (day) => {
    let dateNeeded = moment(day).format("YYYY-MM-DD");
    this.setState({ loadingDay: true });
    const that = this;

    const options = await buildAPIOptions({ date: dateNeeded });
    try {
      let data = await API.post(
        "APIGateway",
        "/v2getStudentsByFilter",
        options,
      );
      that.setState({ loadingDay: false, fetchedStudents: true });
      return data;
    } catch (e) {
      console.log(e);
      return [];
    }
  };

  handleDayOfWeekButton(event) {
    var APIDateStudentResults = this.state.APIDateStudentResults;
    var weekArray = ["sat", "sun", "mon", "tue", "wed", "thu", "fri"];
    var preSlottedFolks = this.state.APIDateStudentResults.filter(
      (x) => x.slot,
    );
    if (preSlottedFolks.length > 0) {
      var slots = preSlottedFolks.map(function (x) {
        return { slotName: x.slot, person: x.fName + " " + x.lName, value: x };
      });
      this.setState({ slots: this.sortSlots(slots, "slotName") });
    }
    let dayOfWeek = this.state.selectedDay.getDay();
    console.log(event.target.id);
    var dayOfExam = "";
    var selectedWeekday = "";

    if (dayOfWeek === 6) {
      let daysToAdd = weekArray.indexOf(event.target.id);
      dayOfExam = moment(this.state.selectedDays[0]).add(daysToAdd, "days");
      selectedWeekday = moment(dayOfExam).format("dddd");

      this.setState({ dayOfExam, activeKey: "slotStudents", selectedWeekday });
    } else {
      dayOfExam =
        this.state.selectedRealDays[weekArray.indexOf(event.target.id)];
      selectedWeekday = moment(dayOfExam).format("dddd");
      this.setState({ dayOfExam, activeKey: "slotStudents", selectedWeekday });
    }
    this.setState({
      unslotedMembers: APIDateStudentResults.filter((x) => !x.slot),
      dataDirty: true,
    });
    return;
  }

  handleFirstNextButton() {
    if (this.state.selectedWeekday.length === 0) {
      var APIDateStudentResults = this.state.APIDateStudentResults;
      var weekArray = ["sat", "sun", "mon", "tue", "wed", "thu", "fri"];
      var preSlottedFolks = this.state.APIDateStudentResults.filter(
        (x) => x.slot,
      );
      if (preSlottedFolks.length > 0) {
        var slots = preSlottedFolks.map(function (x) {
          return {
            slotName: x.slot,
            person: x.fName + " " + x.lName,
            value: x,
          };
        });
        this.setState({ slots: this.sortSlots(slots, "slotName") });
      }
      if (typeof this.state.selectedDay.getDay == "undefined") {
        return;
      }
      let dayOfWeek = this.state.selectedDay.getDay();
      var dayOfExam = "";
      var selectedWeekday = "";

      if (dayOfWeek === 6) {
        let daysToAdd = weekArray.indexOf("sat");
        dayOfExam = moment(this.state.selectedDays[0]).add(daysToAdd, "days");
        selectedWeekday = moment(dayOfExam).format("dddd");

        this.setState({
          dayOfExam,
          activeKey: "slotStudents",
          selectedWeekday,
        });
      } else {
        dayOfExam = this.state.selectedRealDays[weekArray.indexOf("sat")];
        selectedWeekday = moment(dayOfExam).format("dddd");
        this.setState({
          dayOfExam,
          activeKey: "slotStudents",
          selectedWeekday,
        });
      }
      this.setState({
        unslotedMembers: APIDateStudentResults.filter((x) => !x.slot),
        dataDirty: true,
      });
    }
    this.setState({ activeKey: "slotStudents" });
  }

  // Fills in totalProgram/paymentType/initalPayment so both the CSV and
  // xlsx exports report the same numbers for a given student list.
  enrichStudentsForExport = (students) =>
    students.map((student) => {
      student.totalProgram = student.fullPricing
        .map((x) => x.price)
        .reduce((a, b) => a + b, 0);
      // Online registrations are always paid by credit card; manually added
      // students carry their own staff-selected paymentType already.
      if (!student.paymentType) {
        student.paymentType = "Credit Card";
      }
      student.initalPayment = student.totalProgram;
      return student;
    });

  handleFilterDownload = async (event) => {
    this.setState({ loading: true });

    const data = this.enrichStudentsForExport(this.state.APIDateStudentResults);

    this.setState({ filteredData: data, renderDownload: true }, () => {
      this.filterCSVLink.link.click();
      this.setState({ loading: false });
    });
  };

  handleStudentImportXlsxDownload = () => {
    this.setState({ loading: true });

    const data = this.enrichStudentsForExport(this.state.APIDateStudentResults);
    const filename =
      moment(this.state.selectedDay).format("YYYY_MM_DD_") +
      this.state.selectedLocation +
      "_StudentImport.xlsx";

    const { warnings } = downloadStudentImportXlsx(data, filename);

    this.setState({ loading: false, studentImportWarnings: warnings });
  };

  //Modal Functions
  handleModalInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleModalChange(state, view) {
    this.setState({ showModal: state, modalView: view, selectedStudent: 0 });
  }

  handleLessonModalChange(state, index) {
    if (state) {
      let selectedLessonStudent =
        this.state.filteredAPIDateStudentResults[index];
      let selectedLessonStudentIndex = index;
      this.setState({
        selectedLessonStudent,
        newLessonsToAdd: [],
        selectedLessonValue: {},
        selectedLessonStudentIndex,
      });
    }
    this.setState({ showManageLessons: state });
  }

  onRadioPackageChange(e) {
    this.setState({
      roadTestPackageOption: e.currentTarget.id,
    });
  }

  handleAddNewUser(event) {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    this.setState({ addModalValidated: true });
    if (form.checkValidity() === false) {
      return;
    }

    var fullPricing = [];

    var packageChoice = this.state.avaliableOptions.filter(
      (x) => x.package === this.state.roadTestPackageOption,
    )[0];
    fullPricing.push({
      name: packageChoice.package,
      price: parseInt(packageChoice.price),
    });

    if (this.state.addCompletionCertificate) {
      fullPricing.push({
        name: "Completion Certificate",
        price: 25,
      });
    }

    var person = {
      date: moment(this.state.selectedDays[0]).format("YYYY-MM-DD"),
      timestamp: new Date(Date.now()).toISOString(),
      transactionID: "Manual Input",
      paymentStatus: "Manual Input",

      fName: this.state.firstName,
      mName: this.state.middleName,
      lName: this.state.lastName,

      dob: moment(this.state.dateOfBirth).format("YYYY-MM-DD"),
      permitNo: this.state.permitNumber,
      permitDate: moment(this.state.permitIssueDate).format("YYYY-MM-DD"),
      phone: this.state.phoneNumber,
      paymentType: this.state.paymentType,

      weekendDate: this.state.selectedWeekday,
      selectedPackage: this.state.roadTestPackageOption,
      fullPricing: fullPricing,

      emailAddress: this.state.email,
      emailInitalState: "Not Sent",
      emailRoadTestSlotState: "Not Sent",
      emailRoadTestSlotConfirmed: "Email Not Sent",
      emailRoadTestPassedState: "Not Sent",
      drivingSchool: this.state.drivingSchool || "Unknown",

      location: this.state.selectedLocation,
      certPaymentStatus: this.state.addCompletionCertificate,

      bookedLessons: [],
    };

    Object.keys(person).forEach(
      (key) =>
        (person[key] == null || person[key].length === 0) && delete person[key],
    );

    var item = { mode: "addNewStudentNoSlot", student: person };
    var unsavedManuallyAddedStudents = this.state.unsavedManuallyAddedStudents;
    unsavedManuallyAddedStudents.push(item);
    this.setState({ unsavedManuallyAddedStudents });

    this.setState({
      firstName: "",
      middleName: "",
      lastName: "",
      dateOfBirth: "",
      permitNumber: "",
      permitIssueDate: "",
      email: "",
      phoneNumber: "",
      roadTestPackageOption: "",
      paymentType: "",
      drivingSchool: "",
      dataDirty: true,
      certPaymentStatus: false,
      addModalValidated: false,
    });
  }

  subtractUnslottedTime = (selectedUnslottedTimeslotName) => {
    var unslotedGroupTimes = this.state.unslotedGroupTimes;
    console.log(unslotedGroupTimes);
    unslotedGroupTimes = unslotedGroupTimes.filter(
      (x) => x.slotName !== selectedUnslottedTimeslotName,
    );

    this.setState({ unslotedGroupTimes });
  };

  handleAddNewLessons(event) {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    this.setState({ addLessonValidated: true });
    if (form.checkValidity() === false) {
      return;
    }
    this.setState({ loading: true });

    if (this.state.skipExtraLessonsPayment) {
      this.addAdditionalLessons();
      return;
    }

    //Sandbox
    /*  var authData = {
             clientKey: "9kyU8kv89kFp957wAah2jGy2bee63HFx5QRNUhu43pM2b6GWBc7n2ZsX2P5xzh8B",
             apiLoginID: "4D9cPvdnH38"
         }; */

    //PROD
    var authData = {
      clientKey:
        "62CpRk5LpV9a3ZVd3r9ngCk3Uw3Le4ZDAJ8fL8E8n4xMQ653P2hWtGV89HbC22eU",
      apiLoginID: "2w2YM4z9p",
    };

    var cardData = {
      cardNumber: this.state.CCNumber.replace(/\s/g, ""),
      month: this.state.CCExpiration.substring(0, 2),
      year: this.state.CCExpiration.substring(
        this.state.CCExpiration.length - 2,
        this.state.CCExpiration.length,
      ),
      cardCode: this.state.CCCode,
      zip: this.state.CCZip,
      fullName: this.state.CCFirstName + " " + this.state.CCLastName,
    };

    var secureData = {
      authData: authData,
      cardData: cardData,
    };
    try {
      window.Accept.dispatchData(secureData, this.responseHandler);
    } catch (error) {
      console.log(error);
    }
  }

  responseHandler = async (response) => {
    try {
      if (response.messages.resultCode === "Error") {
        var i = 0;
        while (i < response.messages.message.length) {
          console.log(
            response.messages.message[i].code +
            ": " +
            response.messages.message[i].text,
          );
          i = i + 1;
        }
        this.setState({
          CCErrors: "Payment failed: " + response.messages.message[0].text,
        });
      } else {
        //The Authorize NET request was successful!
        var lessonName = this.state.CCLessonsWanted;
        lessonName +=
          this.state.CCLessonsWanted === 1 ? " Extra Lesson" : " Extra Lessons";
        var student = this.state.selectedLessonStudent;
        var newLesson = {
          name: lessonName,
          price: parseInt(this.state.CCLessonsPrice),
        };
        if (student.hasOwnProperty("fullPricing")) {
          var fullPricing = student.fullPricing;
          fullPricing.push(newLesson);
          student.fullPricing = fullPricing;
        } else {
          student.fullPricing = [newLesson];
        }
        this.setState({ CCErrors: "", loading: true });
        const self = this;
        let nonce = response.opaqueData.dataValue;
        let body = {
          nonce: nonce,
          newLesson: newLesson,
          CCFirstName: this.state.CCFirstName,
          CCLastName: this.state.CCLastName,
          CCAddress: this.state.CCAddress,
          CCCity: this.state.CCCity,
          CCState: this.state.CCState,
          CCZip: this.state.CCZip,
          CCCountry: this.state.CCCountry,
          student: student,
          lessonName: lessonName,
          lessonPrice: this.state.CCLessonsPrice,
        };

        const options = await buildAPIOptions(body);

        API.post("APIGateway", "/addNewRoadLessonsPayment", options)
          .then(function (data) {
            if (data.type === "success") {
              self.setState({
                showAddLessons: false,
                CCFirstName: "",
                CCLastName: "",
                CCExpiration: "",
                CCCode: "",
                CCAddress: "",
                CCCity: "",
                CCState: "",
                CCZip: "",
                CCCountry: "",
                CCNumber: "",
                CCLessonsWanted: 0,
                CCLessonsPrice: 0,
                CCErrors: "",
                loading: false,
                addLessonValidated: false,
                skipExtraLessonsPayment: false,
              });
            } else {
              if (
                [
                  "Transaction Failed with error code 2 : This transaction has been declined.",
                  "Transaction Failed with error code 65 : This transaction has been declined.",
                ].includes(data.message)
              ) {
                console.log(
                  "Errors: " +
                  "There was an issue processing your card. Please double check your credit card entries.",
                );
                self.setState({
                  CCErrors:
                    "Payment failed: There was an issue processing your card. Please double check your credit card entries.",
                });
              } else {
                console.log(
                  "Errors: " +
                  "There was an issue processing your card. Please double check your credit card entries." +
                  data.message,
                );
                self.setState({ CCErrors: "Payment failed: " + data.message });
              }
            }
          })
          .catch(function (error) {
            console.log(error);
            if (error.response) {
              self.setState({ CCErrors: error.response.data.message });
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log("Error", error.message);
            }
            self.setState({ loading: false });
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  async addNewStudents() {
    let newStudents = this.state.unsavedManuallyAddedStudents;
    this.setState({ loading: true });
    const that = this;

    const options = await buildAPIOptions(newStudents);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          that.setState({ unsavedManuallyAddedStudents: [], loading: false });
          that.refreshStatus(that.state.activeKey);
        } else {
          //that.setState({ APIDateStudentResults: [] })
          console.log("No students found");
        }
      })
      .catch(function (error) {
        console.log(error);
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        that.setState({ loading: false });
      });
  }

  async handleMoveStudent() {
    this.setState({ loading: true, moveError: "" });

    let student = this.state.APIDateStudentResults[this.state.selectedStudent];

    if (this.state.newEditMoveDate?.label === student.date) {
      this.setState({
        moveError: "The student is already at this date.",
        loading: false,
      });
      return;
    }
    if (
      !moment(this.state.newEditMoveDate?.label, "YYYY-MM-DD", true).isValid()
    ) {
      this.setState({ moveError: "Invalid Date Entry.", loading: false });
      return;
    }

    var studentCopy = { ...student };
    //date is being changed, so we need to update the email data to clear out any potential emails sent.
    if (studentCopy.emailInitalState !== "Not Sent") {
      studentCopy.emailInitalState = "Not Sent";
    }
    if (studentCopy.emailRoadTestPassedState !== "Not Sent") {
      studentCopy.emailRoadTestPassedState = "Not Sent";
    }
    if (studentCopy.emailRoadTestSlotConfirmed !== "Email Not Sent") {
      studentCopy.emailRoadTestSlotConfirmed = "Email Not Sent";
    }
    if (studentCopy.emailRoadTestSlotState !== "Not Sent") {
      studentCopy.emailRoadTestSlotState = "Not Sent";
    }
    if (studentCopy.hasOwnProperty("validateToken")) {
      delete studentCopy.validateToken;
    }
    if (studentCopy.hasOwnProperty("slot")) {
      delete studentCopy.slot;
    }
    if (studentCopy.hasOwnProperty("unslotTime")) {
      delete studentCopy.unslotTime;
    }
    if (studentCopy.hasOwnProperty("weekendDate")) {
      delete studentCopy.weekendDate;
    }

    var item = {
      mode: "moveStudent",
      student: studentCopy,
      newDate: this.state.newEditMoveDate?.label,
      oldDate: studentCopy.date,
    };
    delete studentCopy.date;
    const that = this;

    const options = await buildAPIOptions([item]);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          //Call function that updates students
          that.refreshStatus(that.state.activeKey);
          that.setState({
            loading: false,
            showModal: false,
            modalView: "",
            newEditMoveDate: null,
          });
          //that.setState({ dataDirty: false, showMoveModal: false, selectedStudent: 0, selectedNewDate: that.state.possibleMoveDates[0], loading: false })
        } else {
          console.log("No students found");
        }
      })
      .catch(logAPIError);
  }
  async handleCopyStudent() {
    this.setState({ loading: true, copyError: "" });

    let student = this.state.APIDateStudentResults[this.state.selectedStudent];
    console.log(student);

    if (this.state.newCopyMoveDate?.label === student.date) {
      this.setState({
        copyError: "The student is already at this date.",
        loading: false,
      });
      return;
    }
    if (
      !moment(this.state.newCopyMoveDate?.label, "YYYY-MM-DD", true).isValid()
    ) {
      this.setState({ copyError: "Invalid Date Entry.", loading: false });
      return;
    } else {
      let dow = moment(
        this.state.newCopyMoveDate?.label,
        "YYYY-MM-DD",
        true,
      ).day();
      if (!(dow === 6 || dow === 1)) {
        this.setState({
          copyError: "Date was not a Saturday, or Monday.",
          loading: false,
        });
        return;
      }
    }

    var studentCopy = { ...student };
    delete studentCopy.date;
    if (studentCopy.hasOwnProperty("slot")) {
      delete studentCopy.slot;
    }
    if (studentCopy.hasOwnProperty("unslotTime")) {
      delete studentCopy.unslotTime;
    }
    if (studentCopy.hasOwnProperty("weekendDate")) {
      delete studentCopy.weekendDate;
    }
    var item = {
      mode: "copyStudent",
      student: studentCopy,
      newDate: this.state.newCopyMoveDate?.label,
      oldDate: student.date,
    };
    const that = this;

    const options = await buildAPIOptions([item]);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          //Call function that updates students
          that.refreshStatus(that.state.activeKey);
          that.setState({
            loading: false,
            showModal: false,
            modalView: "",
            newCopyMoveDate: null,
          });
        } else {
          console.log("No students found");
        }
      })
      .catch(logAPIError);
  }
  async handleDeleteStudent() {
    this.setState({ loading: true, deleteError: "" });

    let student = this.state.APIDateStudentResults[this.state.selectedStudent];

    var item = { mode: "deleteStudent", student: student };
    const that = this;

    const options = await buildAPIOptions([item]);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          that.refreshStatus(that.state.activeKey);
          that.setState({ loading: false, showModal: false, modalView: "" });
        } else {
          console.log("No students found");
        }
      })
      .catch(logAPIError);
  }

  handleSlotDurationChange(data) {
    const slotTime = parseInt(data.value);
    this.setState({
      slotTime,
      selectedTimeSlot: data,
      endTime: parseInt(this.state.startTime) + 60 * slotTime,
    });
  }

  handleNewMoveDateChoice(data) {
    this.setState({ newEditMoveDate: data });
  }

  handleNewCopyDateChoice(data) {
    this.setState({ newCopyMoveDate: data });
  }

  uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );
  };

  copyStudentEmailsToClipboard = () => {
    const members = isRMVOrGraniteLocation(this.state.selectedLocation)
      ? this.state.unslotedMembers
      : this.state.slots.map((x) => x.value);
    copyToClipboard(members.map((x) => x.emailAddress).join(","));
  };

  copyParentEmailsToClipboard = () => {
    const members = isRMVOrGraniteLocation(this.state.selectedLocation)
      ? this.state.unslotedMembers
      : this.state.slots.map((x) => x.value);
    copyToClipboard(
      members
        .filter((x) => x.hasOwnProperty("parentEmailAddress"))
        .map((x) => x.parentEmailAddress)
        .join(","),
    );
  };

  copyAllPhoneNumbersToClipboard = () => {
    const members = isRMVOrGraniteLocation(this.state.selectedLocation)
      ? this.state.unslotedMembers
      : this.state.slots.map((x) => x.value);
    copyToClipboard(
      members
        .filter((x) => x.hasOwnProperty("phone"))
        .map((x) => x.phone)
        .join(","),
    );
  };

  sortSlots(array, key) {
    return sortSlotsUtil(array, key);
  }

  handleStudentPick = (selectedOption, index) => {
    var personValue = { ...this.state.slots[index].value };
    var localSlots = this.state.slots.map((slot, i) =>
      i === index
        ? { ...slot, person: selectedOption.label, value: selectedOption.value }
        : slot,
    );
    var unslotedMembers = this.state.unslotedMembers.filter(
      (x) => x.timestamp !== selectedOption.value.timestamp,
    );
    if (
      Object.keys(personValue).length > 0 &&
      personValue.constructor === Object
    ) {
      delete personValue.slot;
      unslotedMembers.push(personValue);
    }
    this.setState({ slots: localSlots, unslotedMembers: unslotedMembers });
  };

  handleUnslottedStudentPick = (selectedOptions, time, index) => {
    console.log(selectedOptions);
    var localUnslotedMembers = this.state.unslotedMembers;
    var finalizedSlots = [];

    if (selectedOptions === null || selectedOptions.length === 0) {
      console.log(time);
      var selectedStudentsWithTimestampSet = localUnslotedMembers
        .filter((x) => x.hasOwnProperty("unslotTime") && x.unslotTime === time)
        .map((x) => x.timestamp);
      console.log(selectedStudentsWithTimestampSet);
      for (let i = 0; i < localUnslotedMembers.length; i++) {
        var student = localUnslotedMembers[i];
        if (selectedStudentsWithTimestampSet.includes(student.timestamp)) {
          delete student.unslotTime;
        }
        finalizedSlots.push(student);
      }
    } else {
      var selectedStudentsWithoutTimestampSet = selectedOptions
        .filter((x) => !x.hasOwnProperty("unslotTime"))
        .map((x) => x.value.timestamp);
      console.log(selectedStudentsWithoutTimestampSet);
      for (let i = 0; i < localUnslotedMembers.length; i++) {
        student = localUnslotedMembers[i];
        if (selectedStudentsWithoutTimestampSet.includes(student.timestamp)) {
          student.unslotTime = time;
          delete student.slot;
        }
        finalizedSlots.push(student);
      }
    }

    this.setState({ unslotedMembers: finalizedSlots });
  };

  handleErrors = (response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response;
  };

  async sendEmail(params) {
    sendEmailAction(
      params,
      (key) => this.refreshStatus(key),
      this.state.activeKey,
      (loading) => this.setState({ loading }),
    );
  }

  async sendInitalEmailBulk(emailRecipient) {
    sendInitalEmailBulkAction(
      emailRecipient,
      {
        filteredAPIDateStudentResults: this.state.filteredAPIDateStudentResults,
        selectedRealDays: this.state.selectedRealDays,
      },
      (params) => this.sendEmail(params),
    );
  }

  async sendRoadTestSlotOrTimeEmailsBulk(useSlotTime, input = []) {
    sendRoadTestSlotOrTimeEmailsBulkAction(
      useSlotTime,
      input,
      {
        selectedLocation: this.state.selectedLocation,
        unslotedMembers: this.state.unslotedMembers,
        slots: this.state.slots,
        dayOfExam: this.state.dayOfExam,
      },
      (params) => this.sendEmail(params),
    );
  }

  async sendRoadTestResultEmailsBulk(
    slotMode,
    template,
    filterSlotted,
    filterUnslotted,
  ) {
    sendRoadTestResultEmailsBulkAction(
      slotMode,
      template,
      filterSlotted,
      filterUnslotted,
      {
        slots: this.state.slots,
        unslotedMembers: this.state.unslotedMembers,
      },
      (params) => this.sendEmail(params),
      (err) => this.setState({ EmailError: err }),
    );
  }

  checkEmailDate() {
    checkEmailDateAction(
      { dayOfExam: this.state.dayOfExam },
      (finalTime) => this.setState({ emailSendDateData: finalTime, EmailError: "" }),
    );
  }

  handleChangeRoadTestStatus = async (index, mode, quantity, useSlots) => {
    var students = [];
    if (useSlots) {
      var shownStudents = this.state.slots.filter(
        (x) =>
          Object.keys(x.value).length > 0 && x.value.constructor === Object,
      );
      if (quantity === "all") {
        shownStudents.forEach(function (student) {
          let studentData = {
            date: student.value.date,
            timestamp: student.value.timestamp,
          };
          var item = { mode: mode, student: studentData };
          students.push(item);
        });
      } else {
        let studentData = {
          date: shownStudents[index].value.date,
          timestamp: shownStudents[index].value.timestamp,
        };
        var item = { mode: mode, student: studentData };
        students.push(item);
      }
    } else {
      shownStudents = this.state.unslotedMembers;
      if (quantity === "all") {
        shownStudents.forEach(function (student) {
          let studentData = {
            date: student.date,
            timestamp: student.timestamp,
          };
          var item = { mode: mode, student: studentData };
          students.push(item);
        });
      } else {
        let studentData = {
          date: shownStudents[index].date,
          timestamp: shownStudents[index].timestamp,
        };
        item = { mode: mode, student: studentData };
        students.push(item);
      }
    }

    const that = this;

    const options = await buildAPIOptions(students);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          //Call function that updates students
          that.refreshStatus("setRoadTestResultEmail");
        } else {
          that.setState({ APIDateStudentResults: [] });
          console.log("No students found");
        }
      })
      .catch(function (error) {
        console.log(error);
        if (error.response) {
          if (error.response.status === 404) {
            that.setState({ APIDateStudentResults: [] });
          }
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  };

  handleSkipStudentLessons = async (mode) => {
    var selectedStudent = this.state.selectedLessonStudent;
    var students = [];
    let studentData = {
      date: selectedStudent.date,
      timestamp: selectedStudent.timestamp,
    };
    var item = { mode: mode, student: studentData };
    students.push(item);

    const that = this;

    const options = await buildAPIOptions(students);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          //Call function that updates students
          that.refreshStatus(that.state.activeKey);
        } else {
          that.setState({ APIDateStudentResults: [] });
          console.log("No students found");
        }
      })
      .catch(function (error) {
        console.log(error);
        if (error.response) {
          if (error.response.status === 404) {
            that.setState({ APIDateStudentResults: [] });
          }
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  };

  handleChangeRoadTestCertificateStatus = async (
    index,
    mode,
    usesStudentSlots,
  ) => {
    var students = [];
    var shownStudents = [];
    if (usesStudentSlots) {
      shownStudents = this.state.slots
        .filter(
          (x) =>
            Object.keys(x.value).length > 0 && x.value.constructor === Object,
        )
        .map((x) => x.value);
    } else {
      shownStudents = this.state.unslotedMembers;
    }
    let studentData = {
      date: shownStudents[index].date,
      timestamp: shownStudents[index].timestamp,
    };
    var item = { mode: mode, student: studentData };
    students.push(item);

    const that = this;

    const options = await buildAPIOptions(students);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          //Call function that updates students
          that.refreshStatus("viewCertStatus");
        } else {
          that.setState({ APIDateStudentResults: [] });
          console.log("No students found");
        }
      })
      .catch(function (error) {
        console.log(error);
        if (error.response) {
          if (error.response.status === 404) {
            that.setState({ APIDateStudentResults: [] });
          }
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
      });
  };

  handleStartTimeChange(time) {
    this.setState({ startTime: time, endTime: time + 60 * this.state.slotTime });
  }
  handleEndtimeTimeChange(time) {
    this.setState({ endTime: time });
  }

  handleSlotMove(index, movement) {
    const delta = movement === "up" ? -1 : 1;
    const neighborIndex = index + delta;
    if (neighborIndex < 0 || neighborIndex >= this.state.slots.length) {
      return;
    }
    var slotLocalCopy = this.state.slots;
    var movedSlot = {
      slotName: slotLocalCopy[neighborIndex].slotName,
      person: slotLocalCopy[index].person,
      value: slotLocalCopy[index].value,
    };
    var neighborSlot = {
      slotName: slotLocalCopy[index].slotName,
      person: slotLocalCopy[neighborIndex].person,
      value: slotLocalCopy[neighborIndex].value,
    };
    slotLocalCopy[neighborIndex] = movedSlot;
    slotLocalCopy[index] = neighborSlot;
    this.setState({ slots: slotLocalCopy });
  }

  handleSlotClear(index) {
    var personValue = { ...this.state.slots[index].value };
    var localSlots = this.state.slots.map((slot, i) =>
      i === index ? { ...slot, value: {}, person: "" } : slot,
    );
    var unslotedMembers = [...this.state.unslotedMembers];
    if (
      Object.keys(personValue).length > 0 &&
      personValue.constructor === Object
    ) {
      delete personValue.slot;
      unslotedMembers.push(personValue);
    }
    this.setState({ slots: localSlots, unslotedMembers: unslotedMembers });
  }

  handleSlotDelete(index) {
    var personValue = { ...this.state.slots[index].value };
    var localSlots = this.state.slots.filter((item, i) => index !== i);
    var unslotedMembers = [...this.state.unslotedMembers];
    if (
      Object.keys(personValue).length > 0 &&
      personValue.constructor === Object
    ) {
      delete personValue.slot;
      unslotedMembers.push(personValue);
    }
    this.setState({ unslotedMembers: unslotedMembers, slots: localSlots });
  }

  async handleSlotSave() {
    this.setState({ loading: true });
    var localSlots = this.state.slots.filter((x) => x.person);
    //We need to update all the slots with the right details.
    for (var pos = 0; pos < localSlots.length; pos++) {
      var slot = localSlots[pos];
      slot.value.slot = slot.slotName;
      slot.value.weekendDate = this.state.selectedWeekday;
      delete slot.value.unslotTime;
      localSlots[pos] = slot;
    }

    this.setState({ slots: localSlots });

    //All values
    var allStudents = [];
    var tempStudents = localSlots.map((x) => x.value);
    for (let index = 0; index < tempStudents.length; index++) {
      var student = tempStudents[index];
      cleanNullProperties(student);
      var item = { mode: "addNewStudent", student: student };
      allStudents.push(item);
    }

    const that = this;

    const options = await buildAPIOptions(allStudents);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        that.refreshStatus("sendSlotEmail");
        console.log(data);
      })
      .catch(logAPIError);
  }

  async handleUnslottedTimeSave() {
    this.setState({ loading: true });
    var localSlots = this.state.unslotedMembers;
    //All values
    var allStudents = [];
    for (let index = 0; index < localSlots.length; index++) {
      var student = localSlots[index];
      cleanNullProperties(student);
      var item = { mode: "addNewStudent", student: student };
      allStudents.push(item);
    }

    const that = this;

    const options = await buildAPIOptions(allStudents);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        that.refreshStatus("sendSlotEmail");
        console.log(data);
      })
      .catch(logAPIError);
  }

  async refreshStatus(newKey) {
    let selectedDay = this.state.selectedDay;
    var location = this.state.selectedLocation;
    let APIDateStudentResults = await this.handleGetSlotsbyDay(selectedDay);

    if (location.length === 0) {
      var selectedLocationSet = new Set(
        APIDateStudentResults.filter((x) => x.location).map((x) => x.location),
      );
      var selectedDateLocations = [...selectedLocationSet];
      if (selectedDateLocations.length > 0) {
        location = selectedDateLocations[0];
      }
    }

    var filteredAPIDateStudentResults = APIDateStudentResults.filter(
      (x) => x.location === location,
    );
    var preSlottedFolks = APIDateStudentResults.filter((x) => x.slot).filter(
      (x) => x.location === location,
    );
    if (preSlottedFolks.length > 0) {
      var slots = preSlottedFolks.map(function (x) {
        return { slotName: x.slot, person: x.fName + " " + x.lName, value: x };
      });
      this.setState({ slots: this.sortSlots(slots, "slotName") });
    }

    this.setState({
      unslotedMembers: APIDateStudentResults.filter((x) => !x.slot),
    });
    //The selected date is the first entry of the selectedDays
    this.setState({
      APIDateStudentResults,
      dataDirty: false,
      activeKey: newKey,
      filteredAPIDateStudentResults,
      selectedLessonStudent:
        filteredAPIDateStudentResults[this.state.selectedLessonStudentIndex],
      unslotedMembers: filteredAPIDateStudentResults.filter((x) => !x.slot),
      refreshStatus:
        "Last refreshed at : " + moment().format("MMMM Do YYYY, h:mm:ss a"),
      loading: false,
    });
  }

  generateSlots = async (event) => {
    this.setState({
      slots: buildGeneratedSlots(
        this.state.startTime,
        this.state.endTime,
        this.state.slotTime,
        this.state.slots,
      ),
    });
  };

  generateUnslottedGroupTimes = async (event) => {
    this.setState({
      unslotedGroupTimes: buildGeneratedUnslottedGroupTimes(
        this.state.startTime,
        this.state.endTime,
        this.state.slotTime,
        this.state.unslotedGroupTimes,
      ),
    });
  };

  fillLeftovers = async (event) => {
    this.setState({
      dataDirty: true,
      slots: buildFilledLeftovers(
        this.state.slots,
        this.state.unslotedMembers,
        this.state.slotTime,
      ),
    });
  };

  renderWeekdayChoices(date) {
    return (
      <div>
        Which day of the week is the Road Test on?
        <br></br>
        {WEEKDAY_BUTTONS.map(({ id, label }) => (
          <Button
            key={id}
            className="padLeft"
            id={id}
            disabled={this.state.selectedWeekday === label}
            onClick={this.handleDayOfWeekButton}
          >
            {label}
          </Button>
        ))}
        <br></br>
        Warning: This will override ALL student dates in this block to the
        selected weekday. Make sure to save student data after updating the
        date!
      </div>
    );
  }

  async saveNewLessons() {
    let newLessons = this.state.newLessonsToAdd;
    let student = this.state.selectedLessonStudent;
    student.newLessons = newLessons;

    this.setState({ loading: true });

    var item = { mode: "addSpecificLessons", student: student };
    const that = this;

    const options = await buildAPIOptions([item]);
    console.log(options);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(async function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          await that.refreshStatus(that.state.activeKey);
          that.setState({ loading: false, newLessonsToAdd: [] });
        } else {
          console.log("No students found");
        }
      })
      .catch(logAPIError);
  }

  async deleteOldLesson(index) {
    let student = this.state.selectedLessonStudent;
    console.log(student, index);
    let removedLesson = student.scheduledLessons.splice(index, 1);
    console.log(removedLesson, student);
    let newStudent = {
      date: student.date,
      timestamp: student.timestamp,
      scheduledLessons: student.scheduledLessons,
      removedLesson: removedLesson,
    };

    this.setState({ loading: true });
    var item = { mode: "deleteSpecificLesson", student: newStudent };
    console.log(item);

    const that = this;

    const options = await buildAPIOptions([item]);
    console.log(options);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          that.refreshStatus(that.state.activeKey);
          that.setState({ loading: false, showModal: false, modalView: "" });
        } else {
          console.log("No students found");
        }
      })
      .catch(logAPIError);
  }

  async addAdditionalLessons() {
    var lessonName = this.state.CCLessonsWanted;
    lessonName +=
      this.state.CCLessonsWanted === 1 ? " Extra Lesson" : " Extra Lessons";
    var student = this.state.selectedLessonStudent;
    var newLesson = {
      name: lessonName,
      price: parseInt(this.state.CCLessonsPrice),
    };
    if (student.hasOwnProperty("fullPricing")) {
      var fullPricing = student.fullPricing;
      fullPricing.push(newLesson);
      student.fullPricing = fullPricing;
    } else {
      student.fullPricing = [newLesson];
    }
    this.setState({ loading: true });
    var item = { mode: "updateStudent", student: student };
    const that = this;

    const options = await buildAPIOptions([item]);
    console.log(options);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(async function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          await that.refreshStatus(that.state.activeKey);
          that.setState({
            loading: false,
            showAddLessons: false,
            CCFirstName: "",
            CCLastName: "",
            CCExpiration: "",
            CCCode: "",
            CCAddress: "",
            CCCity: "",
            CCState: "",
            CCZip: "",
            CCCountry: "",
            CCNumber: "",
            CCLessonsWanted: 0,
            CCLessonsPrice: 0,
            CCErrors: "",
            addLessonValidated: false,
            skipExtraLessonsPayment: false,
          });
        } else {
          console.log("No students found");
        }
      })
      .catch(logAPIError);
  }

  async removeAdditionalLessons(lesson, index) {
    var student = this.state.selectedLessonStudent;
    var lessons = student.fullPricing;
    let finalLessons = [];
    var lessonRemoved = false;
    for (let i = 0; i < lessons.length; i++) {
      if (!lessonRemoved && lessons[i] === lesson) {
        lessonRemoved = true;
        continue;
      }

      finalLessons.push(lessons[i]);
    }
    student.fullPricing = finalLessons;
    this.setState({ loading: true });
    var item = { mode: "updateStudent", student: student };
    const that = this;

    const options = await buildAPIOptions([item]);
    API.post("APIGateway", "/modifystudentdata", options)
      .then(async function (data) {
        if (data.hasOwnProperty("type") && data.type === "success") {
          await that.refreshStatus(that.state.activeKey);
        } else {
          console.log("No students found");
        }
      })
      .catch(logAPIError);
  }

  deleteNewLesson = (index) => {
    console.log(index);
    const newLessonsToAdd = this.state.newLessonsToAdd.filter(
      (_, i) => i !== index,
    );
    this.setState({ newLessonsToAdd });
  };

  handleAddLessonDate = () => {
    let selectedLessonValue = this.state.selectedLessonValue;
    if (Object.keys(selectedLessonValue).length === 0) {
      return;
    }

    let newLessonsToAdd = this.state.newLessonsToAdd;
    if (
      newLessonsToAdd.filter((x) => x.value === selectedLessonValue.value)
        .length === 0
    ) {
      newLessonsToAdd = [...this.state.newLessonsToAdd, selectedLessonValue];
    }

    this.setState({ newLessonsToAdd, selectedLessonValue: {} });
  };

  handleLessonDateChange = (value) => {
    console.log(value, this.state.newLessonsToAdd);
    this.setState({ selectedLessonValue: value });
  };

  loadRoadTestLessonDates = (inputValue) => {
    let selectedLocation = this.state.selectedLocation;
    let keys = Object.keys(this.state.rawRoadTestLessons);
    let rawRoadTestLessons = this.state.rawRoadTestLessons;
    let foundLocations = keys.filter((date) =>
      rawRoadTestLessons[date].locations?.includes(selectedLocation),
    );

    let foundLocationOptions = foundLocations
      .map((date) => moment(date))
      .filter((x) => moment().isBefore(x))
      .map((x) => x.format("YYYY-MM-DD"))
      .map((x) => {
        return { value: x, label: x };
      });

    foundLocationOptions = foundLocationOptions.sort((a, b) =>
      a.value > b.value ? 1 : -1,
    );

    return Promise.resolve(foundLocationOptions);
  };

  makeLessonOptionsLoader = (location) => (inputValue, callback) => {
    let roadTestDate = this.state.selectedDay;
    fetch(
      "https://x4g3mwhate.execute-api.us-east-1.amazonaws.com/dev/getpubliclessondates",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "post",
        body: JSON.stringify({ start: roadTestDate, location: location }),
      },
    )
      .then(this.handleErrors)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        let allTimes = [];

        Object.keys(data).forEach((date) => {
          data[date].forEach((time) => {
            allTimes.push({
              value: location + "|" + date + "T" + time.startTime,
              label:
                moment(date).format("ddd") +
                " " +
                moment(date).format("MM-DD-YYYY") +
                " at " +
                time.timeSlot,
              date: date,
              location: location,
              slot: time.timeSlot,
            });
          });
        });

        allTimes = allTimes.sort((a, b) => (a.value > b.value ? 1 : -1));
        callback(allTimes);
      });
  };

  loadOptions = this.makeLessonOptionsLoader("West Roxbury");
  loadWalpoleOptions = this.makeLessonOptionsLoader("Walpole");
  loadBraintreeOptions = this.makeLessonOptionsLoader("Braintree - Granite St");


  renderUnslottedStudentTimes() {
    // Moved to WeekdaySlotStudentsCard (internal helper)
    return null;
  }

  handleSetLocationAndGetData = async (location) => {
    this.setState({ selectedLocation: location }, () =>
      this.processLocationSlots(),
    );
  };

  renderSendInitialEmailCard() {
    return (
      <SendInitialEmailCard
        selectedDays={this.state.selectedDays}
        selectedLocation={this.state.selectedLocation}
        filteredAPIDateStudentResults={this.state.filteredAPIDateStudentResults}
        dataDirty={this.state.dataDirty}
        loading={this.state.loading}
        locationSelector={this.renderLocationSelector()}
        noDateSelectedPrompt={this.renderNoDateSelectedPrompt()}
        statusAlerts={this.renderStatusAlerts()}
        onSendInitalEmailBulk={(recipients) => this.sendInitalEmailBulk(recipients)}
        onRefreshStatus={() => this.refreshStatus(this.state.activeKey)}
        onSetActiveKey={(key) => this.setState({ activeKey: key })}
      />
    );
  }

  renderSlotStudentsCard() {
    const { activeKey, selectedDay, selectedWeekday, dayOfExam } = this.state;
    return (
      <SlotStudentsCard
        activeKey={activeKey}
        selectedDay={selectedDay}
        selectedWeekday={selectedWeekday}
        dayOfExam={dayOfExam}
        selectedLocation={this.state.selectedLocation}
        unsavedManuallyAddedStudents={this.state.unsavedManuallyAddedStudents}
        selectedTimeSlot={this.state.selectedTimeSlot}
        slotTime={this.state.slotTime}
        startTime={this.state.startTime}
        endTime={this.state.endTime}
        unslotedMembers={this.state.unslotedMembers}
        slots={this.state.slots}
        loading={this.state.loading}
        locationSelector={this.renderLocationSelector()}
        noDateSelectedPrompt={this.renderNoDateSelectedPrompt()}
        onAddNewStudents={this.addNewStudents}
        onSlotDurationChange={this.handleSlotDurationChange}
        onStartTimeChange={this.handleStartTimeChange}
        onEndTimeChange={this.handleEndtimeTimeChange}
        onGenerateSlots={this.generateSlots}
        onStudentPick={this.handleStudentPick}
        onSlotMove={this.handleSlotMove}
        onSlotClear={this.handleSlotClear}
        onSlotDelete={this.handleSlotDelete}
        onSlotSave={this.handleSlotSave}
      />
    );
  }

  renderWeekdaySlotStudentsCard() {
    const { activeKey, selectedWeekday, dayOfExam } = this.state;
    return (
      <WeekdaySlotStudentsCard
        activeKey={activeKey}
        selectedWeekday={selectedWeekday}
        dayOfExam={dayOfExam}
        unsavedManuallyAddedStudents={this.state.unsavedManuallyAddedStudents}
        unslotedGroupTimes={this.state.unslotedGroupTimes}
        selectedTimeSlot={this.state.selectedTimeSlot}
        slotTime={this.state.slotTime}
        startTime={this.state.startTime}
        endTime={this.state.endTime}
        unslotedMembers={this.state.unslotedMembers}
        loading={this.state.loading}
        onAddNewStudents={this.addNewStudents}
        onSlotDurationChange={this.handleSlotDurationChange}
        onStartTimeChange={this.handleStartTimeChange}
        onEndTimeChange={this.handleEndtimeTimeChange}
        onGenerateUnslottedGroupTimes={this.generateUnslottedGroupTimes}
        onUnslottedTimeSave={this.handleUnslottedTimeSave}
        onUnslottedStudentPick={this.handleUnslottedStudentPick}
        onSubtractUnslottedTime={this.subtractUnslottedTime}
      />
    );
  }

  renderSendSlotEmailCard() {
    return (
      <SendSlotEmailCard
        selectedDays={this.state.selectedDays}
        selectedLocation={this.state.selectedLocation}
        refreshStatus={this.state.refreshStatus}
        dataDirty={this.state.dataDirty}
        emailSendDateData={this.state.emailSendDateData}
        unslotedMembers={this.state.unslotedMembers}
        slots={this.state.slots}
        loading={this.state.loading}
        noDateSelectedPrompt={this.renderNoDateSelectedPrompt()}
        noSlottedStudentsPrompt={this.renderNoSlottedStudentsPrompt()}
        onSendRoadTestSlotOrTimeEmailsBulk={(useSlot, input) => this.sendRoadTestSlotOrTimeEmailsBulk(useSlot, input)}
        onCheckEmailDate={this.checkEmailDate}
        onCopyStudentEmails={this.copyStudentEmailsToClipboard}
        onCopyParentEmails={this.copyParentEmailsToClipboard}
        onCopyPhoneNumbers={this.copyAllPhoneNumbersToClipboard}
        onRefreshStatus={() => this.refreshStatus(this.state.activeKey)}
        onSendInitalEmailBulk={(recipients) => this.sendInitalEmailBulk(recipients)}
        onSlotSave={this.handleSlotSave}
      />
    );
  }

  renderLocationSelector() {
    // Uses this.state.locations (sourced from the Locations constant) to stay consistent
    // with the selectDays card, which also uses this.state.locations for location buttons.
    return (
      <div className="location-selector">
        {this.state.locations.map((loc) => (
          <Button
            key={loc}
            disabled={this.state.selectedLocation === loc}
            onClick={() => this.handleSetLocationAndGetData(loc)}
          >
            {loc}
          </Button>
        ))}
      </div>
    );
  }

  renderStatusAlerts() {
    return (
      <>
        {this.state.EmailError ? (
          <Alert variant="warning">
            <strong>{this.state.EmailError}</strong>
          </Alert>
        ) : null}
        {this.state.refreshStatus ? (
          <Alert variant="success">
            <strong>{this.state.refreshStatus}</strong>
          </Alert>
        ) : null}
      </>
    );
  }

  renderNoDateSelectedPrompt() {
    return (
      <div>
        <div>
          A date range was not selected. Please select a date range in order to
          pick a day of the week.
        </div>
        <br></br>
        <Button
          variant="primary"
          onClick={() => this.setState({ activeKey: "selectDays" })}
        >
          Select New Day Range
        </Button>
        <br></br>
      </div>
    );
  }

  renderNoSlottedStudentsPrompt() {
    return (
      <div>
        <div>
          No slotted students found. Please select a new day or slot some
          students.
        </div>
        <div>
          If you slotted students above, you have to hit the save button.
        </div>
        <br></br>
        <Button
          variant="primary"
          onClick={() => this.setState({ activeKey: "selectDays" })}
        >
          Select New Day Range
        </Button>
        <Button
          variant="primary"
          onClick={() => this.setState({ activeKey: "slotStudents" })}
        >
          Slot Some Students
        </Button>
        <br></br>
      </div>
    );
  }

  render() {
    const {
      activeKey,
      selectedDays,
      selectedDay,
      selectedDaysRange,
      selectedWeekday,
      addModalValidated,
      selectedLocation,
      rawRoadTestLessons,
    } = this.state;

    const roadTestDateOptions = Object.keys(rawRoadTestLessons)
      .filter((date) => rawRoadTestLessons[date].locations?.includes(selectedLocation))
      .map((date) => moment(date))
      .filter((x) => moment().isBefore(x))
      .map((x) => x.format("YYYY-MM-DD"))
      .sort()
      .map((x) => ({ value: x, label: x }));


    return (
      <div className="holder">
        <div style={{ marginBottom: "1.25rem" }}>
          <h3 style={{ marginBottom: "0.25rem" }}>Manage Appointments</h3>
          <small className="text-muted">Select a weekend or weekday to manage road test appointments.</small>
        </div>
        <Accordion defaultActiveKey="selectDays" activeKey={activeKey}>
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="selectDays"
              onClick={() => this.setState({ activeKey: "selectDays" })}
            >
              {this.state.selectedDays.length > 0
                ? selectedDaysRange
                : "Select Days"}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="selectDays">
              <Card.Body>
                <div>
                  <DayPicker
                    numberOfMonths={2}
                    selectedDays={selectedDays}
                    showOutsideDays
                    onDayClick={this.handleDayClick}
                  />
                  <br></br>
                  {!this.state.fetchedStudents && selectedDays.length > 0 ? (
                    <div className="text-muted" style={{ marginTop: "0.5rem" }}>
                      <span className="spinner-border spinner-border-sm mr-2" role="status" />
                      {" "}Loading students…
                    </div>
                  ) : null}

                  {this.state.fetchedStudents ? (
                    <div style={{ marginTop: "1rem" }}>
                      <div style={{ marginBottom: "0.5rem" }}>
                        <strong>Location</strong>
                        {this.state.selectedLocation.length > 0 ? (
                          <span className="text-muted" style={{ marginLeft: "0.5rem" }}>
                            — viewing <strong>{this.state.selectedLocation}</strong>
                          </span>
                        ) : (
                          <span className="text-muted" style={{ marginLeft: "0.5rem" }}>— select one below</span>
                        )}
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", marginBottom: "1rem" }}>
                        {this.state.locations.map((location) => (
                          <Button
                            key={location}
                            size="sm"
                            variant={this.state.selectedLocation === location ? "primary" : "outline-secondary"}
                            disabled={this.state.selectedLocation === location}
                            onClick={() => this.handleSetLocationAndGetData(location)}
                          >
                            {location}
                          </Button>
                        ))}
                      </div>

                      {selectedDay ? (
                        <div style={{ marginBottom: "1rem" }}>
                          {this.state.filteredAPIDateStudentResults.length > 0 ? (
                            <Alert variant="info" style={{ padding: "0.4rem 0.75rem", marginBottom: 0 }}>
                              {this.state.filteredAPIDateStudentResults.length} student{this.state.filteredAPIDateStudentResults.length === 1 ? "" : "s"} loaded for this date.
                            </Alert>
                          ) : this.state.selectedLocation.length === 0 && this.state.APIDateStudentResults.length > 0 ? (
                            <Alert variant="warning" style={{ padding: "0.4rem 0.75rem", marginBottom: 0 }}>
                              Multiple locations found — please select a location above.
                            </Alert>
                          ) : (
                            <Alert variant="secondary" style={{ padding: "0.4rem 0.75rem", marginBottom: 0 }}>
                              No students found for this selection.
                            </Alert>
                          )}
                        </div>
                      ) : null}

                      <hr style={{ marginTop: 0 }} />
                      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                        <Button
                          variant="outline-primary"
                          disabled={this.state.loadingDay || this.state.selectedDay.length === 0}
                          onClick={this.handleFirstNextButton}
                        >
                          {this.state.loadingDay ? "Loading…" : "Slot Students"}
                        </Button>
                        <Button
                          variant="outline-primary"
                          disabled={this.state.loadingDay || this.state.selectedDay.length === 0}
                          onClick={() => this.setState({ activeKey: "manageStudents" })}
                        >
                          {this.state.loadingDay ? "Loading…" : "Add / Move / Delete Students"}
                        </Button>
                        <Button
                          variant="outline-secondary"
                          disabled={this.state.loading || this.state.APIDateStudentResults.length === 0}
                          onClick={this.handleFilterDownload}
                        >
                          Download Table Data
                        </Button>
                        <Button
                          variant="outline-secondary"
                          disabled={this.state.loading || this.state.APIDateStudentResults.length === 0}
                          onClick={this.handleStudentImportXlsxDownload}
                        >
                          Download Student Import File (.xlsx)
                        </Button>
                      </div>
                      {this.state.studentImportWarnings.length > 0 && (
                        <Alert
                          variant="warning"
                          dismissible
                          onClose={() => this.setState({ studentImportWarnings: [] })}
                          style={{ marginTop: "0.5rem" }}
                        >
                          <strong>The downloaded Student Import file has some rows that may need review:</strong>
                          <ul style={{ marginBottom: 0 }}>
                            {this.state.studentImportWarnings.map((warning, index) => (
                              <li key={index}>{warning}</li>
                            ))}
                          </ul>
                        </Alert>
                      )}
                      <CSVLink
                        ref={(r) => (this.filterCSVLink = r)}
                        data={this.state.APIDateStudentResults}
                        headers={CSV_HEADERS}
                        className="hidden"
                        filename={
                          moment(this.state.selectedDay).format("YYYY_MM_DD_") +
                          this.state.selectedLocation +
                          "_StudentReport.csv"
                        }
                      />
                    </div>
                  ) : null}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="viewLessonStatus"
              onClick={() => this.setState({ activeKey: "viewLessonStatus" })}
            >
              View Road Test Lesson Status
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="viewLessonStatus">
              <Card.Body>
                <ViewLessonStatusCard
                  activeKey={this.state.activeKey}
                  selectedDays={this.state.selectedDays}
                  selectedLocation={this.state.selectedLocation}
                  filteredAPIDateStudentResults={this.state.filteredAPIDateStudentResults}
                  dataDirty={this.state.dataDirty}
                  statusAlerts={this.renderStatusAlerts()}
                  locationSelector={this.renderLocationSelector()}
                  noDateSelectedPrompt={this.renderNoDateSelectedPrompt()}
                  onSetActiveKey={(key) => this.setState({ activeKey: key })}
                  onRefreshStatus={(key) => this.refreshStatus(key)}
                  onLessonModalChange={(show, index) => this.handleLessonModalChange(show, index)}
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>

          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="manageStudents"
              onClick={() => this.setState({ activeKey: "manageStudents" })}
            >
              Add/Move/Delete Students
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="manageStudents">
              <Card.Body>
                <ManageStudentsCard
                  activeKey={this.state.activeKey}
                  filteredAPIDateStudentResults={this.state.filteredAPIDateStudentResults}
                  refreshStatus={this.state.refreshStatus}
                  selectedDays={this.state.selectedDays}
                  selectedLocation={this.state.selectedLocation}
                  fetchedStudents={this.state.fetchedStudents}
                  unsavedManuallyAddedStudents={this.state.unsavedManuallyAddedStudents}
                  loading={this.state.loading}
                  dataDirty={this.state.dataDirty}
                  locationSelector={this.renderLocationSelector()}
                  noDateSelectedPrompt={this.renderNoDateSelectedPrompt()}
                  onSetActiveKey={(key) => this.setState({ activeKey: key })}
                  onRefreshStatus={(key) => this.refreshStatus(key)}
                  onModalChange={(show, view) => this.handleModalChange(show, view)}
                  onAddNewStudents={this.addNewStudents}
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="sendInitialEmail"
              onClick={() => this.setState({ activeKey: "sendInitialEmail" })}
            >
              Send Inital Emails
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="sendInitialEmail">
              <Card.Body>{this.renderSendInitialEmailCard()}</Card.Body>
            </Accordion.Collapse>
          </Card>

          {this.state.selectedLocation.includes("RMV Site") ||
            this.state.selectedLocation.includes("Braintree - Granite St") ? (
            <>
              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="slotStudents"
                  onClick={this.handleFirstNextButton}
                >
                  Slotting Weekday Students
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="slotStudents">
                  <Card.Body>{this.renderWeekdaySlotStudentsCard()}</Card.Body>
                </Accordion.Collapse>
              </Card>
            </>
          ) : (
            <>
              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="confirmWeekdayDate"
                  onClick={() =>
                    this.setState({ activeKey: "confirmWeekdayDate" })
                  }
                >
                  {selectedWeekday ? (
                    <div>{selectedWeekday}</div>
                  ) : (
                    "Confirm Day of Week for Exam"
                  )}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="confirmWeekdayDate">
                  <Card.Body>
                    {activeKey === "confirmWeekdayDate" ? (
                      <div>
                        {selectedDay ? (
                          <div>{this.renderWeekdayChoices(selectedDay)}</div>
                        ) : (
                          this.renderNoDateSelectedPrompt()
                        )}
                      </div>
                    ) : null}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="slotStudents"
                  onClick={this.handleFirstNextButton}
                >
                  Slotting Students
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="slotStudents">
                  <Card.Body>{this.renderSlotStudentsCard()}</Card.Body>
                </Accordion.Collapse>
              </Card>
            </>
          )}

          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="sendSlotEmail"
              onClick={() => this.setState({ activeKey: "sendSlotEmail" })}
            >
              {this.state.selectedLocation.includes("RMV Site") ||
                this.state.selectedLocation.includes("Braintree - Granite St")
                ? "Send Emails/View Status"
                : "Send Slot Emails/View Status"}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="sendSlotEmail">
              <Card.Body>{this.renderSendSlotEmailCard()}</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="viewCertStatus"
              onClick={() => this.setState({ activeKey: "viewCertStatus" })}
            >
              View Certificate Status
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="viewCertStatus">
              <Card.Body>
                <CertStatusCard
                  activeKey={this.state.activeKey}
                  selectedDays={this.state.selectedDays}
                  selectedLocation={this.state.selectedLocation}
                  unslotedMembers={this.state.unslotedMembers}
                  dataDirty={this.state.dataDirty}
                  slots={this.state.slots}
                  onSelectNewDay={() => this.setState({ activeKey: "selectDays" })}
                  onRefreshStatus={() => this.refreshStatus(this.state.activeKey)}
                  onChangeRoadTestCertificateStatus={this.handleChangeRoadTestCertificateStatus}
                  statusAlerts={this.renderStatusAlerts()}
                  noDateSelectedPrompt={this.renderNoDateSelectedPrompt()}
                  noSlottedStudentsPrompt={this.renderNoSlottedStudentsPrompt()}
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle
              as={Card.Header}
              eventKey="setRoadTestResultEmail"
              onClick={() =>
                this.setState({ activeKey: "setRoadTestResultEmail" })
              }
            >
              Set Road Test Results/Send Road Test Passed Email
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="setRoadTestResultEmail">
              <Card.Body>
                <RoadTestResultCard
                  activeKey={this.state.activeKey}
                  selectedDays={this.state.selectedDays}
                  selectedLocation={this.state.selectedLocation}
                  unslotedMembers={this.state.unslotedMembers}
                  dataDirty={this.state.dataDirty}
                  loading={this.state.loading}
                  slots={this.state.slots}
                  onSelectNewDay={() => this.setState({ activeKey: "selectDays" })}
                  onRefreshStatus={() => this.refreshStatus(this.state.activeKey)}
                  onChangeRoadTestStatus={this.handleChangeRoadTestStatus}
                  onSendRoadTestResultEmailsBulk={this.sendRoadTestResultEmailsBulk}
                  statusAlerts={this.renderStatusAlerts()}
                  noDateSelectedPrompt={this.renderNoDateSelectedPrompt()}
                  noSlottedStudentsPrompt={this.renderNoSlottedStudentsPrompt()}
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        <StudentManagementModal
          showModal={this.state.showModal}
          modalView={this.state.modalView}
          onHide={() => this.setState({ showModal: false, modalView: "", newEditMoveDate: null, newCopyMoveDate: null, moveError: "", copyError: "", deleteError: "" })}
          addModalValidated={addModalValidated}
          drivingSchool={this.state.drivingSchool}
          firstName={this.state.firstName}
          middleName={this.state.middleName}
          lastName={this.state.lastName}
          dateOfBirth={this.state.dateOfBirth}
          permitNumber={this.state.permitNumber}
          permitIssueDate={this.state.permitIssueDate}
          email={this.state.email}
          phoneNumber={this.state.phoneNumber}
          avaliableOptions={this.state.avaliableOptions}
          roadTestPackageOption={this.state.roadTestPackageOption}
          addCompletionCertificate={this.state.addCompletionCertificate}
          paymentType={this.state.paymentType}
          newEditMoveDate={this.state.newEditMoveDate}
          moveError={this.state.moveError}
          newCopyMoveDate={this.state.newCopyMoveDate}
          copyError={this.state.copyError}
          deleteError={this.state.deleteError}
          loading={this.state.loading}
          selectedStudent={this.state.selectedStudent}
          APIDateStudentResults={this.state.APIDateStudentResults}
          onInputChange={this.handleModalInputChange}
          onAddNewUser={this.handleAddNewUser}
          onRadioPackageChange={this.onRadioPackageChange}
          onToggleCompletionCertificate={() =>
            this.setState({
              addCompletionCertificate: !this.state.addCompletionCertificate,
            })
          }
          onSetDrivingSchool={() =>
            this.setState({ drivingSchool: "Parkway Driving School" })
          }
          onNewMoveDateChoice={this.handleNewMoveDateChoice}
          onNewCopyDateChoice={this.handleNewCopyDateChoice}
          onMoveStudent={this.handleMoveStudent}
          onCopyStudent={this.handleCopyStudent}
          onDeleteStudent={this.handleDeleteStudent}
          onStudentPickChange={this.handleModalInputChange}
          roadTestDateOptions={roadTestDateOptions}
        />
        <ManageLessonsModal
          showManageLessons={this.state.showManageLessons}
          onHide={() => this.setState({ showManageLessons: false, modalView: "" })}
          selectedLessonStudent={this.state.selectedLessonStudent}
          avaliableOptions={this.state.avaliableOptions}
          newLessonsToAdd={this.state.newLessonsToAdd}
          selectedLessonLocation={this.state.selectedLessonLocation}
          selectedLessonValue={this.state.selectedLessonValue}
          selectedDay={this.state.selectedDay}
          showAddLessons={this.state.showAddLessons}
          showRemoveLessons={this.state.showRemoveLessons}
          loading={this.state.loading}
          addLessonValidated={this.state.addLessonValidated}
          skipExtraLessonsPayment={this.state.skipExtraLessonsPayment}
          CCNumber={this.state.CCNumber}
          CCFirstName={this.state.CCFirstName}
          CCLastName={this.state.CCLastName}
          CCExpiration={this.state.CCExpiration}
          CCCode={this.state.CCCode}
          CCAddress={this.state.CCAddress}
          CCCity={this.state.CCCity}
          CCState={this.state.CCState}
          CCZip={this.state.CCZip}
          CCCountry={this.state.CCCountry}
          CCLessonsWanted={this.state.CCLessonsWanted}
          CCLessonsPrice={this.state.CCLessonsPrice}
          CCErrors={this.state.CCErrors}
          loadOptions={this.loadOptions}
          loadWalpoleOptions={this.loadWalpoleOptions}
          loadBraintreeOptions={this.loadBraintreeOptions}
          onSetLessonLocation={(loc) =>
            this.setState({ selectedLessonLocation: loc, selectedLessonValue: {} })
          }
          onLessonDateChange={this.handleLessonDateChange}
          onAddLessonDate={this.handleAddLessonDate}
          onDeleteNewLesson={this.deleteNewLesson}
          onSaveNewLessons={this.saveNewLessons}
          onDeleteOldLesson={this.deleteOldLesson}
          onSkipStudentLessons={this.handleSkipStudentLessons}
          onShowAddLessons={() => this.setState({ showAddLessons: true })}
          onShowRemoveLessons={() => this.setState({ showRemoveLessons: true })}
          onRemoveAdditionalLessons={this.removeAdditionalLessons}
          onModalInputChange={this.handleModalInputChange}
          onToggleSkipPayment={() =>
            this.setState({ skipExtraLessonsPayment: !this.state.skipExtraLessonsPayment })
          }
          onAddNewLessons={this.handleAddNewLessons}
        />
      </div>
    );
  }
}
